import { CreateSphere } from '@babylonjs/core/Meshes/Builders/sphereBuilder';
import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { Color3 } from '@babylonjs/core/Maths/math.color';
import { ViewerEvents, BaseExtension } from '@immersive-tech/viewer-engine';

import type { Viewer, Nullable } from '@immersive-tech/viewer-engine';
import type { Mesh } from '@babylonjs/core/Meshes/mesh';

export class CameraTargetHelper extends BaseExtension {
  private helperMesh: Nullable<Mesh>;

  constructor(viewer: Viewer) {
    super(viewer);

    this.helperMesh = null;

    this.viewer.addEventListener(ViewerEvents.VIEWER_INITIALIZED, this.viewerInitializedEventHandler.bind(this));
  }

  protected afterSceneRenderCallback() {
    if (!this.viewer.camera) return;

    this.helperMesh?.position.copyFrom(this.viewer.camera.target);
  }

  protected viewerInitializedEventHandler() {
    if (!this.viewer.scene) return;

    this.createHelper();

    this.viewer.scene.onAfterRenderObservable.add(this.afterSceneRenderCallback.bind(this));
  }

  protected createHelper() {
    if (!this.viewer.scene) return;

    const helperMaterial = new StandardMaterial('cameraTargetHelperMaterial', this.viewer.scene);

    helperMaterial.emissiveColor = new Color3(0, 0.5, 0);
    helperMaterial.alpha = 0.5;

    this.helperMesh = CreateSphere('cameraTargetHelper', { diameter: 0.05 });
    this.helperMesh.material = helperMaterial;
    this.helperMesh.isPickable = false;

    this.viewer.scene.removeMesh(this.helperMesh);
  }

  public showHelper() {
    if (!this.viewer.scene || !this.helperMesh) return;

    this.viewer.scene.addMesh(this.helperMesh);
  }

  public hideHelper() {
    if (!this.viewer.scene || !this.helperMesh) return;

    this.viewer.scene.removeMesh(this.helperMesh);
  }
}
